import { Route } from '@angular/router';
import { CallbackComponent } from '../lib/callback/callback.component';
import { BannerComponent } from '../lib/banner/banner.component';
import { LoginRedirectComponent } from '../lib/login-redirect/login-redirect.component';
import { Banner } from '../lib/data/banner.data';
import { envs } from '../lib/data/env.data';
let routes: Route[] = [];
const childRoutes = [
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'login',
    component: LoginRedirectComponent,
  },
  {
    path: '',
    component: BannerComponent,
  },
];
if (envs.useParamsForBanner) {
  routes = [
    {
      path: Banner.SHOPRITE,
      children: childRoutes,
    },
    {
      path: Banner.FRESHGROCER,
      children: childRoutes,
    },
    {
      path: Banner.PRICERITE,
      children: childRoutes,
    },
    {
      path: Banner.DEARBORN,
      children: childRoutes,
    },
    {
      path: Banner.GOURMETGARAGE,
      children: childRoutes,
    },
    {
      path: Banner.FAIRWAY,
      children: childRoutes,
    },
    {
      path: Banner.DIBRUNO,
      children: childRoutes,
    },
  ];
} else {
  routes = [
    {
      path: 'callback',
      component: CallbackComponent,
    },
    {
      path: 'login',
      component: LoginRedirectComponent,
    },

    { path: '', component: BannerComponent },
  ];
}
export const appRoutes: Route[] = routes;
